<script>
import DatePicker from "vue-datepicker-next";
export default {
    props: ["title", "modelValue", "range"],
    name: "FilterInput",
    emits: ["update:modelValue"],
    components: { DatePicker },
    data() {
        return {
            values: [],
        };
    },
    watch: {
        modelValue: function (newValue) {
            // If "pageData" ever changes, then we will console log its new value.
            this.values = newValue;
        },
    },
};
</script>

<template>
    <div class="filter">
        <label class="title">{{ title }}:</label>
        <div v-if="range == 'true'">
            <date-picker v-model:value="values" :range="range" type="date" value-type="date" class="control"
                @change="$emit('update:modelValue', values)">
                <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                        <button class="mx-btn mx-btn-text" @click="this.$parent.thisweekStart(emit)">
                            Ši savaitė
                        </button>
                        <button class="mx-btn mx-btn-text" @click="this.$parent.today(emit)">
                            Šiandien
                        </button>
                    </div>
                </template>
            </date-picker>
        </div>

        <div v-else>
            <date-picker v-model:value="values" type="date" value-type="date" class="control"
                @change="$emit('update:modelValue', values)">
                <template v-slot:footer="{ emit }">
                    <div style="text-align: left">
                        <button class="mx-btn mx-btn-text" @click="this.$parent.todaysingle(emit)">
                            Šiandien
                        </button>
                    </div>
                </template>
            </date-picker>
        </div>
    </div>
</template>

<style>
.mx-input:hover,
.mx-input:focus {
    border: 1px solid #ccc !important;
    border-color: #ccc !important;
}

</style>